import {Box, Button, Card, CardContent, CircularProgress, Grid, Link, Paper, Stack, Typography} from "@mui/material";
import {PersonRemove, PrintOutlined, SaveOutlined} from "@mui/icons-material";
import PropTypes from "prop-types";
import {styled} from "@mui/material/styles";
import {useGetStatementInfoQuery} from "../../../store/statement/statementApi";
import {useEffect, useState} from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import copyObject from "../../../utils/copyObject";
import {useListEmployeesQuery} from "../../../store/employee/employeeApi";
import {
    useAddEmployeeToPracticeStatementMutation,
    useEditPracticeStatementGeneralInfoMutation,
    useRemoveEmployeeFromPracticeStatementMutation, useRemovePracticeStatementMutation
} from "../../../store/practice/practiceApi";
import {useGetStudentsInGroupQuery} from "../../../store/group/groupApi";
import AddIcon from "@mui/icons-material/Add";

PracticeStatementInfoBlock.propTypes = {
    statement: PropTypes.object,
    printEnabled: PropTypes.bool,
    adminMode: PropTypes.bool,
    addStudentHandler: PropTypes.func
}

export default function PracticeStatementInfoBlock(props){
    console.log(props.statement);
    const [statementIsLoading, setStatementIsLoading] = useState(false);
    const [practiceKind, setPracticeKind] = useState(props.statement?.practiceKind);
    const [practiceType, setPracticeType] = useState(props.statement?.practiceType);
    const [closingDate, setClosingDate] = useState(props.statement?.closingDate);
    const [creationDate, setCreationDate] = useState(props.statement?.creationDate);
    const [statementNumber, setStatementNumber] = useState('');
    const [copyOfStatement, setCopyOfStatement] = useState(props.statement);
    const [employeeChair, setEmployeeChair] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [employees, setEmployees] = useState([]);
    const [students, setStudents] = useState([]);
    const {data: allEmployees} = useListEmployeesQuery();
    const {data: studentsList} = useGetStudentsInGroupQuery({groupId: props.statement?.groupId});
    const [copyOfStudentsList, setCopyOfStudentsList] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [editPracticeStatementGeneralInfo] = useEditPracticeStatementGeneralInfoMutation();
    const [removeEmployeeRequest] = useRemoveEmployeeFromPracticeStatementMutation();
    const [addEmployeeRequest] = useAddEmployeeToPracticeStatementMutation();
    const [removeStatementRequest] = useRemovePracticeStatementMutation();
    
    let newPracticeType = props.statement?.practiceType;
    const [refresh, setRefresh] = useState(false);
    const Item = styled(Paper)(({theme}) => ({
        backgroundColor: '#F9FAFB',
        ...theme.typography.body2,
        textAlign: 'start',
    }));
    
    useEffect(() => {
        setPracticeKind(copyObject(props.statement?.practiceKind));
        setPracticeType(copyObject(props.statement?.practiceType));
        setClosingDate(props.statement?.closingDate === null ? null : copyObject(props.statement?.closingDate));
        setCreationDate(copyObject(props.statement?.creationDate));
        setStatementNumber(copyObject(props.statement?.statementNumber));
        newPracticeType = copyObject(props.statement?.practiceType);
        setCopyOfStatement(copyObject(props.statement));
        setEmployees(copyObject(props.statement?.employees));
        // setEmployees(copyObject(props.statement?.employees));
        
        if (studentsList) {
            setCopyOfStudentsList(copyObject(studentsList.data));
        }
    },[props.adminMode, studentsList]);
    
    function applyVisualChanges() {
        setRefresh(!refresh);
    }

    function formatDate(dateObj) {
        if (!dateObj)
            return '';
        
        return `${dateObj.getFullYear()}-${withZero(dateObj.getMonth() + 1)}-${withZero(dateObj.getDate())}`;
    }

    function toDateString(date){
        return new Date(date).toLocaleDateString("ru-RU");
    }

    function withZero(num) {
        return num < 10 ? `0${num}` : num;
    }

    function nameOfPracticeKind(practiceKind) {
        switch (practiceKind)
        {
            case 1: return 'учебная';
            case 2: return 'производственная';
            default: return '';
        }
    }

    function downloadStatement() {
        setStatementIsLoading(true);
        fetch(`/Reports/PracticeStatement?statementId=${props.statement.practiceStatementId}&fileType=pdf`,
            {
                method: "GET",
                headers: { "semesterid": localStorage.getItem("selectedSemesterId"), "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem('token')}`}
            }).then(response => {
            setStatementIsLoading(false);
            return response.blob();
        }).then(response => {
            const url = window.URL.createObjectURL(
                new Blob([response]),
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `Ведомость по практике.pdf`,
            );

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        })
    }
    
    async function removeEmployee(employee) {
        console.log('trying to remove', employee);
        setEmployees(employees.filter((item) => item.key !== employee.key));

        const request = {
            practiceStatementId: props.statement.practiceStatementId,
            employeeId: parseInt(employee.key, 10)
        };

        setIsSaving(true);

        await removeEmployeeRequest({data: request}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                console.log('Преподаватель успешно удален')
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsSaving(false);
        }).catch(() => {
            alert('Ошибка');
            setIsSaving(false);
        });
    }
    
    function handleTypeUpdate(val) {
        setPracticeType(val);
    }
    
    async function handleAddEmployee(event) {
        employees.push({
            key: event.target.value.employeeId.toString(), 
            value: `${event.target.value.lastName} ${event.target.value.firstName} ${event.target.value.middleName}`
        });

        const request = {
            practiceStatementId: props.statement.practiceStatementId,
            employeeId: event.target.value.employeeId
        };

        setIsSaving(true);

        await addEmployeeRequest({data: request}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                console.log('Преподаватель успешно добавлен')
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsSaving(false);
        }).catch(() => {
            alert('Ошибка');
            setIsSaving(false);
        });
        
        setSelectedEmployee(event.target.value);
        
        // applyVisualChanges();
    }

    function handleAddStudent(event) {
        students.push(event.target.value);
        
        setSelectedStudent(event.target.value);
    }
    
    async function removeStatement(practiceStatementId) {
        if (!props.adminMode) {
            alert('У вас нет прав для удаления ведомостей');
            return;
        }
        
        if (!window.confirm('Вы действительно хотите удалить ведомость?'))
            return;
        
        const request = {
            practiceStatementId
        };
        
        await removeStatementRequest({data: request}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                alert('Ведомость успешно удалена')
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }
        });
    }
    
    async function saveData() {
        const request = {
            practiceStatementId: props.statement.practiceStatementId,
            closingDate: !closingDate || closingDate === {} ? null : closingDate,
            creationDate,
            statementNumber: copyOfStatement.statementNumber
        };
        
        setIsSaving(true);

        await editPracticeStatementGeneralInfo({data: request}).unwrap().then((fulfilled) => {
            if (fulfilled?.success) {
                alert('Сохранено')
            } else {
                fulfilled.errors.map((item) => {
                    alert(item);
                    return 1;
                });
            }

            setIsSaving(false);
        }).catch(() => {
            alert('Ошибка');
            setIsSaving(false);
        });
    }

    return (
        <>
            <Stack direction="row" spacing={4}>
                <Typography variant="h5">Информация о ведомости</Typography>
                {props.printEnabled
                    ? (<Button startIcon={statementIsLoading ? <CircularProgress size={15} /> : <PrintOutlined /> } 
                               variant="outlined" 
                               color="primary"
                               onClick={() => downloadStatement()}>Печать</Button>)
                    : (<></>)}

                {props.adminMode
                ? <Button variant={'outlined'} color={'error'} onClick={() => removeStatement(props.statement.practiceStatementId)}>Удалить ведомость</Button>
                : <></>}
            </Stack>

            <br/>
            <Box sx={{flexGrow: 1}}>
                <Grid container spacing={2}>
                    <Grid item md={6}>
                        <Item>
                            <Stack spacing={3}>
                                <Typography><strong>Вид, тип практики: </strong>
                                    {props.adminMode && false
                                    ? <Stack direction={'row'} spacing={1}>
                                        <Select value={practiceKind}
                                                onChange={(event) => { setPracticeKind(event.target.value) }}
                                                size={'small'}>
                                            <MenuItem key={1} value={1}>Учебная</MenuItem>
                                            <MenuItem key={2} value={2}>Производственная</MenuItem>
                                        </Select>
                                            
                                        <TextField onBlur={(event) => {setPracticeType(newPracticeType)}}
                                                   defaultValue={practiceType}
                                                   onChange={(event) => {newPracticeType = event.target.value;}}
                                                   size={'small'}/>
                                        </Stack>
                                    : <>{nameOfPracticeKind(props.statement?.practiceKind)}, {props.statement?.practiceType}</>}
                                </Typography>
                                <Typography><strong>Группа: </strong>{props.statement?.groupName}</Typography>
                                <Typography><strong>Преподаватели: </strong>
                                    {props.adminMode
                                        ? <>
                                            <ol>
                                                {employees?.map((item) => {
                                                    return <li key={item.key}><IconButton size={'small'} 
                                                                                          onClick={() => {removeEmployee(item)}}
                                                                                          color={'error'}><PersonRemove /></IconButton> {item.value}</li>
                                                })}
                                            </ol>
                                        </>
                                        : <>{props.statement?.employees?.map((item)=>item.value).join(', ')}</>}
                                </Typography>

                                {props.adminMode
                                ? <><Typography><strong>Добавить преподавателя</strong></Typography>
                                        <TextField size={'small'}
                                                   select
                                                   value={employeeChair}
                                                   onChange={(event) => setEmployeeChair(event.target.value)}
                                                   label={'Кафедра'}>
                                            {allEmployees?.data?.map((item) => {
                                                return <MenuItem key={item.chairId} value={item}>{item.chairName}</MenuItem>
                                            })}
                                        </TextField>

                                        <TextField size={'small'}
                                                   select
                                                   value={selectedEmployee}
                                                   onChange={(event) => {handleAddEmployee(event)}}
                                                   label={'Преподаватель'}>
                                            {employeeChair?.employees?.map((item) => {
                                                return <MenuItem key={item.employeeId} value={item}>{item.lastName} {item.firstName} {item.middleName}</MenuItem>
                                            })}
                                        </TextField></>
                                : <></>}

                                {props.adminMode
                                    ? <>
                                        <Typography><strong>Добавить студента</strong></Typography>
                                        <TextField size={'small'}
                                                   select
                                                   value={selectedStudent}
                                                   onChange={(event) => {handleAddStudent(event)}}
                                                   label={'Студент'}>
                                            {copyOfStudentsList?.sort((l,r) => l.value > r.value ? 1 : -1).map((item) => {
                                                return <MenuItem key={item.value} value={item}>{item.value}</MenuItem>
                                            })}
                                        </TextField>
                                        {selectedStudent
                                        ? <>
                                            <Card>
                                                <CardContent>
                                                    <Stack direction={'row'} spacing={2} alignItems={'center'}>
                                                        <Typography>{selectedStudent.value}</Typography>
                                                        <Button variant={'contained'} 
                                                                onClick={() => { props.addStudentHandler(parseInt(selectedStudent.key, 10)) }}
                                                                startIcon={<AddIcon />}>Добавить</Button>
                                                    </Stack>
                                                </CardContent>
                                            </Card>
                                            </>
                                        : <></>}
                                    </>
                                    : <></>}
                            </Stack>
                        </Item>
                    </Grid>
                    <Grid item md={6}>
                        <Item>
                            <Stack spacing={3}>
                                <Typography><strong>Статус: </strong>{props.statement?.closingDate !== null ? 'Ведомость закрыта' : 'Ведомость открыта'}</Typography>
                                
                                {props.adminMode
                                    ? <Typography><strong>Номер ведомости: </strong>
                                        <TextField size={'small'}
                                                   onInput={(event) => {copyOfStatement.statementNumber = event.target.value;}}
                                                   defaultValue={copyOfStatement?.statementNumber}/>
                                    </Typography>
                                    : <></>}
                                
                                <Typography><strong>Дата выдачи: </strong>
                                    {props.adminMode
                                        ? <>
                                            <TextField size={'small'}
                                                       type={'date'}
                                                       onChange={(event) => {setCreationDate(event.target.value);}}
                                                       value={formatDate(new Date(creationDate))}/>
                                        </>
                                        : (props.statement?.creationDate !== null && props.statement?.creationDate !== undefined ? toDateString(props.statement?.creationDate) : '-')}
                                </Typography>
                                <Typography><strong>Дата закрытия: </strong>
                                    {props.adminMode
                                    ? <>
                                        <TextField size={'small'} 
                                                   type={'date'} 
                                                   onChange={(event) => {setClosingDate(event.target.value);}}
                                                   value={closingDate === null ? null : formatDate(new Date(closingDate))}/>
                                        </>
                                    : (props.statement?.closingDate !== null && props.statement?.closingDate !== undefined ? toDateString(props.statement?.closingDate) : '-')}
                                </Typography>
                                {props.adminMode
                                ? <Button variant={'contained'} 
                                          onClick={() => {saveData()}}
                                          disabled={isSaving}
                                          startIcon={isSaving ? <CircularProgress size={15} /> :<SaveOutlined />}>Сохранить изменения</Button>
                                : <></>}
                            </Stack>
                        </Item>
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}